import type { ITranslationLanguage } from '../challenges/enums/translation-language';
import { LANGUAGE_SLUG_BY_CODE } from './language-slug-map';

export function getLanguageSlug(code: ITranslationLanguage): string {
  return LANGUAGE_SLUG_BY_CODE[code] ?? code;
}
